export let EModel;
(function (EModel) {
  EModel["None"] = "none";
  EModel["All"] = "all";
  EModel["Activity"] = "activity";
  EModel["ActionQueueItem"] = "actionQueueItem";
  EModel["Appointment"] = "appointment";
  EModel["AppointmentType"] = "appointmentType";
  EModel["Availability"] = "availability";
  EModel["Broadcast"] = "broadcast";
  EModel["Campaign"] = "campaign";
  EModel["ChatActivity"] = "chatActivity";
  EModel["Diagnosis"] = "diagnosis";
  EModel["Facility"] = "facility";
  EModel["Fax"] = "faxDocument";
  EModel["FeedbackResponse"] = "feedbackResponse";
  EModel["FileUpload"] = "fileUpload";
  EModel["Followup"] = "followup";
  EModel["Group"] = "group";
  EModel["Hl7message"] = "hl7message";
  EModel["Insurance"] = "insurance";
  EModel["Intent"] = "intent";
  EModel["Invoke"] = "invoke";
  EModel["Message"] = "message";
  EModel["MessageFailure"] = "messageFailure";
  EModel["MessageTemplate"] = "messageTemplate";
  EModel["Offer"] = "offer";
  EModel["OutboundNumber"] = "outboundNumber";
  EModel["Patient"] = "patient";
  EModel["PatientForm"] = "patientForm";
  EModel["PatientFormTemplate"] = "patientFormTemplate";
  EModel["PatientMessageTemplate"] = "patientMessageTemplate";
  EModel["Procedure"] = "procedure";
  EModel["Provider"] = "provider";
  EModel["Recall"] = "recall";
  EModel["Referral"] = "referral";
  EModel["Reminder"] = "reminder";
  EModel["Schedule"] = "schedule";
  EModel["Sync"] = "sync";
  EModel["Telehealth"] = "telehealth";
  EModel["User"] = "user";
  EModel["WaitingRoomPatient"] = "waitingRoomPatient";
  EModel["Waitlist"] = "waitlist";
  EModel["Page"] = "page";
})(EModel || (EModel = {}));
export let EModelFilterComparision;
(function (EModelFilterComparision) {
  EModelFilterComparision["Eq"] = "eq";
  EModelFilterComparision["Gt"] = "gt";
  EModelFilterComparision["Gte"] = "gte";
  EModelFilterComparision["Lt"] = "lt";
  EModelFilterComparision["Lte"] = "lte";
  EModelFilterComparision["Ne"] = "ne";
  EModelFilterComparision["RegEx"] = "regex";
  EModelFilterComparision["Js"] = "js";
  EModelFilterComparision["Cron"] = "cron";
})(EModelFilterComparision || (EModelFilterComparision = {}));